import React from 'react';
import PropTypes from 'prop-types';
import './Button.scss';

/**
 * Primary UI component for user interaction
 */
export const Button = ({
  type,
  primary,
  backgroundColor,
  label,
  href,
  children,
  onClick,
  disabled,
  target,
  ...props
}) => {
  const mode = primary ? 'button--primary' : 'button-secondary';

  return href ? (
    <a
      href={href}
      onClick={onClick}
      target={target}
      className={['button', mode, { ...props }.className].join(' ')}>
      <span style={{ position: 'relative', zIndex: 9 }}>{children}</span>
    </a>
  ) : (
    <button
      /* eslint-disable-next-line react/button-has-type */
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={['button', mode, { ...props }.className].join(' ')}>
      <span style={{ position: 'relative', zIndex: 9 }}>{children}</span>
    </button>
  );
};

Button.propTypes = {
  type: PropTypes.string,
  /**
   * Is this the principal call to action on the page?
   */
  primary: PropTypes.bool,
  /**
   * What background color to use
   */
  backgroundColor: PropTypes.string,

  /**
   * Button contents
   */
  label: PropTypes.string,

  // href

  href: PropTypes.string,
  /**
   * Optional click handler
   */
  onClick: PropTypes.func,

  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  disabled: PropTypes.bool,
  target: PropTypes.string,
};

Button.defaultProps = {
  type: 'button',
  backgroundColor: null,
  primary: '',
  onClick: undefined,
  disabled: false,
  target: null,
};

export default Button;
